module.exports = __webpack_public_path__ + "img/close_red.7f5814df.svg";